// extracted by mini-css-extract-plugin
module.exports = {"filter":"RecipientsFilter_filter__1hC1B","searchFilter":"RecipientsFilter_searchFilter__tBfDm","resetFilter":"RecipientsFilter_resetFilter__2xrlS"};